export const formatService = {
  getListByTime: function (ary) {
    let obj = {
      title: '',
      gambit: ary
    }
    let arr = []

    arr.push(obj)
    return arr
  }
}



// WEBPACK FOOTER //
// ./src/service/formatService.js